/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import Props from './Props';
import CenteredSpinner from '../../../../components/CenteredSpinner';

class RememberMe extends React.Component<Props> {

	static defaultProps: Props = {
		onSubmitRememberMeToken: () => {
			// do nothing
		}
	};

	componentDidMount(): void {
		setTimeout(
			() => this.handleSubmitRememberMeToken(),
			1
		);
	}

	handleSubmitRememberMeToken = (): void => {
		const props: Readonly<Props> = this.props;

		props.onSubmitRememberMeToken();
	};

	render(): ReactNode {
		return (
			<CenteredSpinner/>
		);
	}
}

export default RememberMe;
